import ClientLogin from '../views/client/ClientLogin.vue'
import ClientRegister from '../views/client/ClientRegister.vue'
import ClientDashboard from '../views/client/ClientDashboard.vue'
import EarnPoints from '../views/client/EarnPoints.vue'
import EnterRebateItems from '../views/client/EnterRebateItems.vue'
import RedeemPoints from '../views/client/RedeemPoints.vue'
import TrainingCatalog from '../views/client/TrainingCatalog.vue'
import TrainingModule from '../views/client/TrainingModule.vue'
import ClientProgramNotFound from '../views/client/ClientProgramNotFound.vue'
import RulesAndTerms from '../views/client/RulesAndTerms.vue'
import Account from '../views/client/Account.vue'

// guest: no auth allowed, requiresAuth: needs to be authenticated, isAdmin: needs to be an admin, empty if all allowed

const routes = [
  {
    path: '/program/:slug/register',
    name: 'ClientRegister',
    component: ClientRegister,
    meta: {
      guest: true,
      layout: 'client-inverse'
    }
  },
  {
    path: '/program/:slug/login',
    name: 'ClientLogin',
    component: ClientLogin,
    meta: {
      guest: true,
      layout: 'client-login'
    }
  },
  {
    path: '/program/:slug/dashboard',
    name: 'ClientDashboard',
    component: ClientDashboard,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/program/:slug/earn-points',
    name: 'EarnPoints',
    component: EarnPoints,
    meta: {
      requiresAuth: true,
      layout: 'client-inverse'
    }
  },
  {
    path: '/program/:slug/enter-items',
    name: 'EnterRebateItems',
    component: EnterRebateItems,
    meta: {
      requiresAuth: true,
      layout: 'client-inverse'
    }
  },
  {
    path: '/program/:slug/redeem-points',
    name: 'RedeemPoints',
    component: RedeemPoints,
    props: true,
    meta: {
      requiresAuth: true,
      layout: 'client-inverse'
    }
  },
  {
    path: '/program/:slug/training-catalog',
    name: 'TrainingCatalog',
    component: TrainingCatalog,
    meta: {
      requiresAuth: true,
      layout: 'client-inverse'
    }
  },
  {
    path: '/program/:slug/training-module',
    name: 'TrainingModule',
    component: TrainingModule,
    props: true,
    meta: {
      requiresAuth: true,
      layout: 'client-inverse'
    }
  },
  {
    path: '/program/:slug/rules-and-terms',
    name: 'RulesAndTerms',
    component: RulesAndTerms,
    meta: {
      requiresAuth: true,
      layout: 'client-inverse'
    }
  },
  {
    path: '/program/:slug/account',
    name: 'Account',
    component: Account,
    meta: {
      requiresAuth: true,
      layout: 'client-inverse'
    }
  },
  {
    path: '/program-not-found',
    name: 'ClientProgramNotFound',
    component: ClientProgramNotFound,
    meta: {
      layout: 'client-inverse'
    }
  }
]

routes
  .filter(route => !('layout' in route.meta))
  .forEach(route => (route.meta = { ...route.meta, ...{ layout: 'client' } }))

export { routes }
